export const replacePlaceholders = (text: string, values = {}): string =>
  text?.replace(/\$([a-zA-Z_][a-zA-Z0-9_]*)/g, (match: string, key: string) =>
    key in values ? values[key as keyof typeof values] : match,
  )
